var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecureData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 472,
    viewBox: "0 0 490 472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.992 304.673L76.996 328.938L35 304.673L76.996 280.407L118.992 304.673Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.008 280.408L118.992 304.673L76.9961 280.408L118.992 256.142L161.008 280.408Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.004 256.142L161.008 280.407L118.992 256.142L161.008 231.876L203.004 256.142Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245 231.877L203.004 256.142L161.008 231.877L203.004 207.611L245 231.877Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M286.996 207.611L245 231.877L203.004 207.611L245 183.346L286.996 207.611Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.008 328.938L118.992 353.204L76.9961 328.938L118.992 304.673L161.008 328.938Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.004 304.673L161.008 328.938L118.992 304.673L161.008 280.407L203.004 304.673Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M245 280.408L203.004 304.673L161.008 280.408L203.004 256.142L245 280.408Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M286.996 256.142L245 280.407L203.004 256.142L245 231.876L286.996 256.142Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M329.012 231.877L286.996 256.142L245 231.877L286.996 207.611L329.012 231.877Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M203.004 353.204L160.988 377.469L118.992 353.204L160.988 328.938L203.004 353.204Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M245 328.938L203.004 353.204L160.988 328.938L203.004 304.673L245 328.938Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M286.996 304.673L245 328.938L203.004 304.673L245 280.407L286.996 304.673Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M328.992 280.408L286.996 304.673L245 280.408L286.996 256.142L328.992 280.408Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M371.008 256.142L328.992 280.407L286.996 256.142L328.992 231.876L371.008 256.142Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M245 377.469L203.004 401.734L160.988 377.469L203.004 353.204L245 377.469Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M286.996 353.204L245 377.469L203.004 353.204L245 328.938L286.996 353.204Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M328.992 328.938L286.996 353.204L245 328.938L286.996 304.673L328.992 328.938Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M371.008 304.673L328.992 328.938L286.996 304.673L328.992 280.407L371.008 304.673Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M413.004 280.408L371.008 304.673L328.992 280.408L371.008 256.142L413.004 280.408Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M286.996 401.735L245 426L202.984 401.735L245 377.469L286.996 401.735Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M328.992 377.469L286.996 401.734L245 377.469L286.996 353.204L328.992 377.469Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M370.988 353.204L328.992 377.469L286.996 353.204L328.992 328.938L370.988 353.204Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M413.004 328.938L370.988 353.204L328.992 328.938L370.988 304.673L413.004 328.938Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M455 304.673L413.004 328.938L370.988 304.673L413.004 280.407L455 304.673Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M245 231.876V183.345L203.004 159.08L161.008 183.345V231.876L203.004 256.142L245 231.876Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M245 231.877L203.004 256.142V207.611L245 183.346V231.877Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M203.004 207.611L161.008 231.876V183.345L203.004 159.08V207.611Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.004 256.142L161.008 231.877V183.346L203.004 207.611V256.142Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M245 183.345L203.004 207.611L161.008 183.345L203.004 159.08L245 183.345Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M245 183.346V134.815L203.004 110.549L161.008 134.815V183.346L203.004 207.611L245 183.346Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M245 183.346L203.004 207.611V159.08L245 134.815V183.346Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M203.004 159.08L161.008 183.346V134.815L203.004 110.549V159.08Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M203.004 207.611L161.008 183.346V134.815L203.004 159.08V207.611Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M245 134.815L203.004 159.08L161.008 134.815L203.004 110.549L245 134.815Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M245 134.815V86.284L203.004 62.0186L161.008 86.284V134.815L203.004 159.08L245 134.815Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M245 134.815L203.004 159.08V110.55L245 86.2842V134.815Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M203.004 110.549L161.008 134.815V86.284L203.004 62.0186V110.549Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M203.004 159.08L161.008 134.815V86.2842L203.004 110.55V159.08Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M245 86.284L203.004 110.549L161.008 86.284L203.004 62.0186L245 86.284Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M161.008 328.938V280.408L118.992 256.142L76.9961 280.408V328.938L118.992 353.204L161.008 328.938Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M161.008 328.939L118.992 353.204V304.673L161.008 280.408V328.939Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M118.992 304.673L76.9961 328.938V280.408L118.992 256.142V304.673Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M118.992 353.204L76.9961 328.939V280.408L118.992 304.673V353.204Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M161.008 280.408L118.992 304.673L76.9961 280.408L118.992 256.142L161.008 280.408Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M161.008 280.408V231.877L118.992 207.611L76.9961 231.877V280.408L118.992 304.673L161.008 280.408Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M161.008 280.408L118.992 304.673V256.142L161.008 231.877V280.408Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M118.992 256.142L76.9961 280.408V231.877L118.992 207.611V256.142Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M118.992 304.673L76.9961 280.408V231.877L118.992 256.142V304.673Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M161.008 231.877L118.992 256.142L76.9961 231.877L118.992 207.611L161.008 231.877Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M226.107 124.017L308.083 171.421C321.028 178.896 328.992 192.72 328.992 207.69C328.992 222.661 336.977 236.484 349.941 243.98L396.897 271.073",
    stroke: "#0F1936",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M455 304.673V256.142L413.004 231.876L371.008 256.142V304.673L413.004 328.938L455 304.673Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M455 304.673L413.004 328.938V280.408L455 256.142V304.673Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M413.004 280.407L371.008 304.673V256.142L413.004 231.876V280.407Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M413.004 328.938L371.008 304.673V256.142L413.004 280.408V328.938Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M455 256.142L413.004 280.407L371.008 256.142L413.004 231.876L455 256.142Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M391.996 292.55L322.372 334.298C299.348 347.508 271.047 347.469 248.083 334.199L142.787 273.367",
    stroke: "#0F1936",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M328.158 343.337C336.53 343.337 343.316 336.546 343.316 328.168C343.316 319.791 336.53 313 328.158 313C319.787 313 313 319.791 313 328.168C313 336.546 319.787 343.337 328.158 343.337Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M338.295 318.29C338.29 318.271 338.284 318.253 338.279 318.235C338.458 318.417 338.631 318.603 338.798 318.793M338.295 318.29L338.162 318.157C337.716 317.71 337.245 317.302 336.755 316.93C339.07 322.443 338.009 329.048 333.514 333.528M338.295 318.29L338.798 318.793M338.295 318.29C339.888 323.766 338.548 329.922 334.221 334.235M333.514 333.528C329.017 338.028 322.427 339.088 316.919 336.768C317.292 337.258 317.703 337.729 318.154 338.18C318.199 338.225 318.243 338.269 318.288 338.313M333.514 333.528L334.221 334.235C334.221 334.235 334.221 334.235 334.221 334.235M333.514 333.528L334.22 334.236C334.22 334.236 334.22 334.236 334.221 334.235M318.288 338.313C318.22 338.293 318.151 338.272 318.083 338.252C317.474 338.066 316.874 337.843 316.287 337.584C316.643 338.035 317.029 338.469 317.447 338.887C323.376 344.82 332.961 344.82 338.889 338.887C344.581 333.192 344.809 324.126 339.573 318.16L338.87 318.865L338.798 318.793M318.288 338.313C323.756 339.905 329.896 338.563 334.221 334.235M318.288 338.313C323.836 343.722 332.688 343.678 338.182 338.18C343.507 332.852 343.713 324.365 338.798 318.793",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M196.158 318.337C204.53 318.337 211.316 311.546 211.316 303.168C211.316 294.791 204.53 288 196.158 288C187.787 288 181 294.791 181 303.168C181 311.546 187.787 318.337 196.158 318.337Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M202.24 309.235C206.568 304.922 207.907 298.766 206.315 293.29L206.817 293.793C211.732 299.365 211.527 307.852 206.202 313.18C200.708 318.678 191.856 318.722 186.308 313.313C191.776 314.905 197.915 313.563 202.24 309.235Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M280.159 170.337C288.53 170.337 295.317 163.546 295.317 155.168C295.317 146.791 288.53 140 280.159 140C271.787 140 265 146.791 265 155.168C265 163.546 271.787 170.337 280.159 170.337Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M280.5 181C294.584 181 306 169.583 306 155.5C306 141.417 294.584 130 280.5 130C266.417 130 255 141.417 255 155.5C255 169.583 266.417 181 280.5 181Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M328.5 354C342.584 354 354 342.583 354 328.5C354 314.417 342.584 303 328.5 303C314.417 303 303 314.417 303 328.5C303 342.583 314.417 354 328.5 354Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5 329C210.584 329 222 317.583 222 303.5C222 289.417 210.584 278 196.5 278C182.417 278 171 289.417 171 303.5C171 317.583 182.417 329 196.5 329Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M286.106 161.119C290.434 156.806 291.774 150.65 290.181 145.173L290.684 145.676C295.598 151.249 295.393 159.735 290.068 165.064C284.574 170.562 275.722 170.606 270.174 165.197C275.642 166.789 281.781 165.447 286.106 161.119Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M455 256.142C455 140.075 360.988 46 245 46C129.012 46 35 140.075 35 256.142V304.673",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureData);
export default __webpack_public_path__ + "static/media/secureData.8e07aef62a0aae2698e26adda43c8d8e.svg";
export { ForwardRef as ReactComponent };